import { render, staticRenderFns } from "./WorkExperienceForm.vue?vue&type=template&id=2f1be289&scoped=true"
import script from "./WorkExperienceForm.vue?vue&type=script&lang=ts"
export * from "./WorkExperienceForm.vue?vue&type=script&lang=ts"
import style0 from "./WorkExperienceForm.vue?vue&type=style&index=0&id=2f1be289&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1be289",
  null
  
)

export default component.exports